// extracted by mini-css-extract-plugin
module.exports = {"landing":"styles_landing__2n9fl","current":"styles_current__36-tx","title":"styles_title__729Bo","text":"styles_text__HPyt3","button":"styles_button__1HcDT"};